import React from 'react';
import './ActiveBalloon.styl';
import Popover from 'components/pure/utils/Popover';
import classNames from 'classnames';

class ActiveBalloon extends React.Component {
  constructor(props) {
    super(props);

    this.onMouseLeavePopover = this.onMouseLeavePopover.bind(this);
    this.onMouseOverPopover = this.onMouseOverPopover.bind(this);
    this.state = {popoverVisible: false};
  }

  onMouseOverPopover() {
    this.setState({popoverVisible: true});
  }

  onMouseLeavePopover() {
    this.setState({popoverVisible: false});
  }

  render() {
    const {popoverText, children} = this.props;
    const {popoverVisible} = this.state;

    return (
      <div className="active-balloon-wrapper">
        <Popover
          className="destyle-popover"
          canAutoPosition={false}
          open={popoverVisible}
          useLayerForClickAway={false}
          anchorEl={this.wrapper}
          anchorOrigin={{
            horizontal: 'right',
            vertical: 'bottom',
          }}
          targetOrigin={{
            horizontal: 'left',
            vertical: 'top',
          }}>
          <div className={classNames('tooltip-container', 'no-tail')}>
            <div className="ev-tooltip">
              <div className="tooltip-content">{popoverText}</div>
            </div>
          </div>
        </Popover>
        <span
          className={'active-balloon'}
          onMouseOver={this.onMouseOverPopover}
          onMouseLeave={this.onMouseLeavePopover}
          ref={r => (this.wrapper = r)}
        />
        {children}
      </div>
    );
  }
}

export default ActiveBalloon;
